













import PopupEpisode2 from '@/views/templates/tenugui/PopupEpisode2.vue'

export default
  components: {
    PopupEpisode2
  }

  data: () ->
    message: [
      'CHAORAS®では染色方法は4つあります。<br>
1.捺染（なせん）　2.注染（ちゅうせん）<br>
3.タイダイ　4.草木染め<br>
<br>
いずれも吸水性を保てる染色方法で、デザインに合わせてチョイスしています。CHAORAS®のてぬぐいは職人技術を結集して染め上げられています。'
    ]

  methods: {
    closePopup: () ->
      @$emit('closePopup')
    add_point: (point) ->
      @$emit('addPoint', point)
  }
